/* eslint-disable */
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class AdminCommerce<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  pricing = (params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminCommerce/Pricing`, method: "GET", secure: true, ...params });
  setPricing = (data: any, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminCommerce/Pricing`, method: "POST", body: data, secure: true, type: ContentType.Json, ...params });
  promo = (params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminCommerce/Promo`, method: "GET", secure: true, ...params });
  setPromo = (data: any, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminCommerce/Promo`, method: "POST", body: data, secure: true, type: ContentType.Json, ...params });
  discounts = (params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminCommerce/Discounts`, method: "GET", secure: true, ...params });
  createDiscount = (data: any, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminCommerce/Discount`, method: "POST", body: data, secure: true, type: ContentType.Json, ...params });
  updateDiscount = (id: string, data: any, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminCommerce/Discount/${id}`, method: "PUT", body: data, secure: true, type: ContentType.Json, ...params });
  deleteDiscount = (id: string, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminCommerce/Discount/${id}`, method: "DELETE", secure: true, ...params });
  orders = (params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminCommerce/Orders`, method: "GET", secure: true, ...params });
  salesBySource = (params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminCommerce/SalesBySource`, method: "GET", secure: true, ...params });
  consultationsBySource = (params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminCommerce/ConsultationsBySource`, method: "GET", secure: true, ...params });
  markInstallment = (installmentId: string, paid: boolean, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminCommerce/Installment/${installmentId}`, method: "POST", query: { paid }, secure: true, ...params });
  invoice = (invoiceId: string, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminCommerce/Invoice/${invoiceId}`, method: "GET", secure: true, ...params });
  deleteOrder = (id: string, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminCommerce/Order/${id}`, method: "DELETE", secure: true, ...params });
}
